import { render, staticRenderFns } from "./AudioCommercials.vue?vue&type=template&id=eb9886f4&"
import script from "./AudioCommercials.vue?vue&type=script&lang=ts&"
export * from "./AudioCommercials.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports